
import React, { useEffect, useState } from 'react';
import { cmsDetailsAction } from '../../../features/webCommonSlice';
import moment from 'moment';
import CmsPageShimmer from '../CmsPageShimmer/CmsPageShimmer';

const HowToPlay = () => {
    // const [loader, setLoader] = useState(false)
    // const [cmsDetails, setCmsDetails] = useState({});

    // useEffect(() => {
    //     setLoader(true)
    //     cmsDetailsAction({ slug: "how-it-works" }, (response) => {
    //         if (response?.status === true) {
    //             setCmsDetails(response?.data)
    //         }
    //         setLoader(false)
    //     })();
    // }, [cmsDetailsAction])

    return (
        <>
            <div className='cms_landing_page'>
                <div className='banner'>
                    How To Play
                    {/* {cmsDetails.title} */}
                </div>
                <div className='container'>
                    {/* {!loader ?
                        <div className='cms_content_text'>
                            <div dangerouslySetInnerHTML={{ __html: cmsDetails.description }}></div>
                        </div>
                        :
                        <>
                            <CmsPageShimmer />
                        </>
                    } */}
                    <div className="cms_content_text">
                        <h2 className="ql-align-justify">
                            <strong>Join A Contest</strong>
                        </h2>
                        <p className="ql-align-justify"><br /></p>
                        <p className="ql-align-justify">Select the live match in your favourite game mode and join a contest using your wallet balance.</p>
                        <p className="ql-align-justify"><br /></p>
                        <h2 className="ql-align-justify"><strong>Create Your Team</strong></h2>
                        <p className="ql-align-justify"><br /></p>
                        <p className="ql-align-justify">Select Wicket-Keeper (Minimum- 1, Maximum 4)</p>
                        <p className="ql-align-justify"><br /></p>
                        <p className="ql-align-justify">Select Batsmen (Minimum- 3, Maximum 6)</p>
                        <p className="ql-align-justify"><br /></p>
                        <p className="ql-align-justify">Select All-rounders (Minimum-1, Maximum- 4)</p>
                        <p className="ql-align-justify"><br /></p>
                        <p className="ql-align-justify">Select Bowlers (Minimum-3, Maximum- 6)</p>
                        <p className="ql-align-justify"><br /></p>
                        <p className="ql-align-justify">You can select a maximum of 7 players from one playing side and try out different combinations of your choice. Every user must choose their players by following team selection criteria given above.</p>
                        <p className="ql-align-justify"><br /></p>
                        <h2 className="ql-align-justify"><strong>Add Money</strong></h2>
                        <p className="ql-align-justify"><br /></p>
                        <p className="ql-align-justify">Go to you wallet section and add money using your preferred payment channel.</p>
                        <p className="ql-align-justify"><br /></p>
                        <p className="ql-align-justify">To see the points system please visit the <a href="/points-system" rel="noopener noreferrer" target="_blank">www.millionaire11.com/points-system</a></p>
                        <p className="ql-align-justify"><br /></p>
                    </div>

                </div>
            </div>
        </>
    )
}

export default HowToPlay